import React from 'react'

const Billing = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/billing',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M10 19c-4.966 0-9-4.034-9-9s4.034-9 9-9 9 4.034 9 9-4.034 9-9 9z'
        stroke={primaryColor}
        strokeWidth='1.2'
      />
      <path
        d='M7.182 9.595h1.157V8.243c0-.52.067-.953.201-1.3.135-.347.325-.628.573-.845a2.16 2.16 0 0 1 .883-.462 4.48 4.48 0 0 1 1.151-.136c.433 0 .83.043 1.19.13.36.087.673.19.942.312l-.273 1.196a4.367 4.367 0 0 0-.754-.253 3.847 3.847 0 0 0-.936-.111c-.494 0-.85.115-1.066.345-.217.23-.325.604-.325 1.124v1.352h2.21v1.274H9.873c-.13.858-.49 1.573-1.079 2.145h4.147v1.274H7v-1.157c.373-.33.663-.674.871-1.034.208-.36.347-.769.416-1.228H7.182V9.595z'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Billing
